import { isEncryptedDataValid } from './encryptedData.js';
import { getNonEmptyStringErrors } from './helpers.js';
import { getKeyValidationErrors } from './validation.js';

const getBookingProceduresErrors = procedures => {
  const procedureIDs = Object.keys(procedures !== null && procedures !== void 0 ? procedures : {});
  return procedureIDs.length > 0 ? null : 'Expected at least one procedure';
};

const sharedBookingValidationKeys = {
  id: true,
  creationTimestamp: true,
  orderID: true,
  procedures: getBookingProceduresErrors
};

const getBookingPatientIDErrors = patientID => {
  if (!patientID) return 'Expected patientID';
  if (!isEncryptedDataValid(patientID)) return 'Expected encrypted patientID';
  return null;
};

const encryptedBookingValidationKeys = Object.assign(Object.assign({}, sharedBookingValidationKeys), {
  patientID: getBookingPatientIDErrors
});
/**
 * Determine whether an object of type Partial<EncryptedBooking> meets
 * all requirements to be non-partial
 */

const isEncryptedBookingValid = booking => !getKeyValidationErrors(booking, encryptedBookingValidationKeys);
/**
 * Evaluate an object of type Partial<EncryptedBooking> with all
 * required properties to resolve a non-partial type
 */

const getValidatedEncryptedBooking = booking => {
  if (!isEncryptedBookingValid(booking)) {
    throw Error('Booking is missing required properties');
  }

  return booking;
};
const bookingValidationKeys = Object.assign(Object.assign({}, sharedBookingValidationKeys), {
  patientID: getNonEmptyStringErrors
}); // TODO: rename

/**
 * Determine whether an object of type Partial<Booking> meets
 * all requirements to be non-partial
 */

const isUnencryptedBookingValid = booking => !getKeyValidationErrors(booking, bookingValidationKeys); // TODO: rename

/**
 * Evaluate an object of type Partial<Booking> with all
 * required properties to resolve a non-partial type
 */

const getValidatedUnencryptedBooking = booking => {
  if (!isUnencryptedBookingValid(booking)) {
    throw Error(`Booking does not pass validation:
      ${getKeyValidationErrors(booking, bookingValidationKeys)}`);
  }

  return booking;
};

export { getValidatedEncryptedBooking, getValidatedUnencryptedBooking, isEncryptedBookingValid, isUnencryptedBookingValid };
